import { format } from './checkBox'

const dropDown = {
  format,
}

export default dropDown
